<template>
  <file-input
      ref="fileInput"
      :color="color"
      :icon="icon"
      :accept="accept"
      :multiple="false"
      :disabled="disabled"
      :tip="$t('Добавить файл')"
      @change="changeFiles" />
</template>

<style scoped>
::v-deep .v-list-item__title {
  white-space: pre-wrap !important;
}
</style>

<script>
  import FileInput from './FileInput.vue'

  export default {
    components: {
      FileInput
    },
    props: {
      value: {
        type: Object
      },
      accept: {
        type: String,
        default: '.xls,.xlt,.xla,.xlsx,.xltx,.xlsm,.xltm,.xlam,.xlsb,.doc,.dot,.docx,.dotx,.docm,.dotm,.pdf,.tif,.tiff,.ico,.jpeg,.jpg,.bmp,.png,.csv,.sig,.xml,.rar,.zip,.7z,.txt'
      },
      color: {
        type: String,
        default: 'green'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: 'attach_file'
      },
      maxFileSize: {
        type: Number,
        default: 31457280
      }
    },
    data () {
      return {
        file: null
      }
    },
    computed: {
      maxFileSizeError () {
        return this.$t('Максимальный размер загружаемых файлов 50 Мб')
      }
    },
    methods: {
      changeFiles: function (file) {
        if (!file) {
          return
        }
        if (file.size > this.maxFileSize) {
          this.showErrorAction({
            message: this.maxFileSizeError
          })
        }
        this.$emit('change', file)
      }
    }
  }
</script>
